import React, { useState, useEffect, useRef } from "react";
import RightDot from "../../assets/svg/reportspage/ArrowRightCircle.svg";
import WrongDot from "../../assets/svg/reportspage/ArrowWrongCircle.svg";
import Gray from "../../assets/svg/reportspage/graydot.svg";
import CircleProgressBar from "./circleProgressBar";
import persent from "../../assets/svg/reportspage/persent.svg";
import up from "../../assets/svg/reportspage/up.svg";
import down from "../../assets/svg/reportspage/down.svg";
import time from "../../assets/svg/reportspage/time.svg";
import target from "../../assets/svg/reportspage/target.svg";
import Phy from "../../assets/svg/emsat/Physics.svg";
import Chem from "../../assets/svg/emsat/Chemistry.svg";
import MAthIcon from "../../assets/svg/emsat/Mathametics.svg";
import zoo from "../../assets/svg/emsat/zoo.svg";
import botany from "../../assets/svg/emsat/botany.svg";
import Biology from "../../assets/svg/emsat/bio.svg";
import Logical from "../../assets/svg/emsat/logical.svg";
import Science from "../../assets/svg/emsat/science.svg";
import Critical from "../../assets/svg/emsat/critical.svg";
import Probelm from "../../assets/svg/emsat/problem.svg";
import { useAnalytics } from "../../contexts/AnalyticsContext";

const AdvanceReport = ({ advanceReport, examdetailes }) => {
  const subjects = advanceReport?.sections?.map((report) => report.SECTION);
  const [selectedButton, setSelectedButton] = useState(subjects?.[0] || null);
  const [expandedChapters, setExpandedChapters] = useState({});
  const analytics = useAnalytics();

  const loadStartTimeRef = useRef(null);
  const viewStartTimeRef = useRef(null);
  const [hasRecordedLoadTime, setHasRecordedLoadTime] = useState(false);
  const [loadTimeSecs, setLoadTimeSecs] = useState(0);
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (advanceReport && !hasRecordedLoadTime) {
      loadStartTimeRef.current = Date.now();
      setHasRecordedLoadTime(true);
    }
  }, [advanceReport, hasRecordedLoadTime]);

  useEffect(() => {
    if (advanceReport && loadStartTimeRef.current !== null && !viewStartTimeRef.current) {
      const loadTime = Date.now() - loadStartTimeRef.current;
      setLoadTimeSecs(Math.floor(loadTime / 1000));
      viewStartTimeRef.current = Date.now();
    }
  }, [advanceReport]);

  useEffect(() => {
    return () => {
      if (viewStartTimeRef.current !== null && !hasTrackedRef.current) {
        hasTrackedRef.current = true;
        const timeSpentMs = Date.now() - viewStartTimeRef.current;
        if (analytics && typeof analytics.trackAdvanceReportViewed === "function") {
          analytics.trackAdvanceReportViewed(loadTimeSecs, timeSpentMs);
        }
      }
    };
  }, [analytics, loadTimeSecs]);

  const handleButtonClick = (subject) => {
    setSelectedButton(subject);
  };

  const handleExpand = (index) => {
    setExpandedChapters((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const selectedReport = advanceReport?.sections?.find((report) => report.SECTION === selectedButton);

  const secondsToMinutes = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
    return `${minutes}m ${Math.round(formattedSeconds)}s`;
  };

  const getImage = (subject) => {
    if (!subject) return Science;

    switch (subject) {
      case "Physics":
        return Phy;
      case "Chemistry":
        return Chem;
      case "Mathematics":
        return MAthIcon;
      case "Botany":
        return botany;
      case "Zoology":
        return zoo;
      case "Biology":
        return Biology;
      case "Science":
        return Science;
      case "Critical Thinking":
        return Critical;
      case "Logical Reasoning":
        return Logical;
      case "Problem Solving":
        return Probelm;
      case "Hots":
        return Probelm;
      default:
        return Science;
    }
  };

  if (!advanceReport) {
    return null;
  }

  return (
    <div>
      <div className="Rep_subject_cont">
        {advanceReport?.sections?.map((value, key) => (
          <button
            key={key}
            onClick={() => handleButtonClick(value.SECTION)}
            className={`tab_subject ${selectedButton === value.SECTION ? "selected_tab" : ""}`}
          >
            <span>
              <img className="Rep_subject_icon" src={getImage(value?.SECTION)} alt={value.SECTION || "subject"} />
            </span>{" "}
            {value.SECTION}
          </button>
        ))}
      </div>
      {selectedReport && (
        <div className="Rep_card-cont">
          {(examdetailes?.event_type?.toLowerCase() ?? "") !== "offline" ? (
            <div className="Rep_score_card Rep_score_card3">
              <div className="saparator_v"></div>
              <div className="saparator_h"></div>
              <div className="Rep_score_card2">
                <div className="Rep_score_cardinner">
                  <img src={persent} alt="percentage icon" />
                  <div>
                    <h3 className="Rep_score_inner_title">Score</h3>
                    <p className="Rep_score_inner_marks">
                      {selectedReport.MARKS_ACHIEVED}/{selectedReport.TOTAL_MARKS}
                    </p>
                  </div>
                </div>
                <div className="Rep_score_cardinner">
                  <img src={target} style={{ width: "2.5rem" }} alt="percentage icon" />
                  <div>
                    <h3 className="Rep_score_inner_title">Accuracy</h3>
                    <p className="Rep_score_inner_marks">{`${selectedReport?.ACCURACY || 0}%`}</p>
                  </div>
                </div>
              </div>
              <div className="Rep_score_card2">
                <div className="Rep_score_cardinner">
                  <img src={time} alt="percentage icon" />
                  <div>
                    <h3 className="Rep_score_inner_title">Total Time taken</h3>
                    <p className="Rep_score_inner_marks">{secondsToMinutes(selectedReport?.TOTAL_TIME_TAKEN)}</p>
                  </div>
                </div>
                <div className="Rep_score_cardinner">
                  <img src={time} alt="percentage icon" />
                  <div>
                    <h3 className="Rep_score_inner_title">Avg. time/ Question</h3>
                    <p className="Rep_score_inner_marks">{secondsToMinutes(selectedReport?.AVG_TIME_TAKEN)}</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="Rep_score_card4 ">
              <div className="saparator_v"></div>
              <div className="Rep_score_cardinner">
                <img src={persent} alt="percentage icon" />
                <div>
                  <h3 className="Rep_score_inner_title">Score</h3>
                  <p className="Rep_score_inner_marks">
                    {selectedReport?.CORRECT}/{selectedReport?.TOTAL_MARKS}
                  </p>
                </div>
              </div>
              <div className="Rep_score_cardinner">
                <img src={target} alt="percentage icon" />
                <div>
                  <h3 className="Rep_score_inner_title">Accuracy</h3>
                  <p className="Rep_score_inner_marks">{`${selectedReport?.ACCURACY || 0}%`}</p>
                </div>
              </div>
            </div>
          )}

          <CircleProgressBar
            totalMarks={selectedReport.TOTAL_QUESTIONS}
            correctMarks={selectedReport.CORRECT}
            incorrectMarks={selectedReport.INCORRECT}
            unattempted={selectedReport.UNATTEMPTED}
          />
        </div>
      )}
      <div className="AdRp-main-cont">
        <div className="AdRp-header-cont">
          <p className="AdRp-header-contp1">Chapter</p>
          <p className="AdRp-header-contp2">Total</p>
          <p className="AdRp-header-contp3">Correct/Wrong/Unattempted</p>
          <p className="AdRp-header-contp4">Marks Achieved</p>
        </div>
        {selectedReport?.chapters?.map((chapter, index) => {
          const chapterNameWords = chapter.CHAPTER.split(" ");
          const isLongChapterName = chapterNameWords.length > 2;
          const chapterStyle = {
            fontSize: isLongChapterName ? "12px" : "inherit"
          };

          const performanceStyle = {
            color: chapter.PERFORMANCE_METRICS === "Keep it up" ? "#2CBE6A" : "#FF5353",
            marginBottom: isLongChapterName ? "1rem" : "0rem"
          };

          return (
            <div key={index} className="AdRp-bodyitems">
              <div className="AdRp-bodyitems1">
                <h3 style={chapterStyle}>{chapter.CHAPTER}</h3>
                <p style={performanceStyle}>{chapter.PERFORMANCE_METRICS}</p>
              </div>
              <div className="AdRp-bodyitems2">{chapter.TOTAL_QUESTIONS_ASKED}</div>
              <div className="AdRp-bodyitems3">
                <img src={RightDot} alt="Correct Icon" /> <p>{chapter.QUESTION_STATUS_CORRECT}</p>
                <img src={WrongDot} alt="Wrong Icon" /> <p>{chapter.QUESTION_STATUS_WRONG}</p>
                <img src={Gray} alt="Unattempted Icon" /> <p>{chapter.QUESTION_STATUS_UNATTEMPTED}</p>
              </div>
              <div className="AdRp-bodyitems4">
                <p>
                  <span>{chapter.MARKS_SCORED}</span>/{chapter.TOTAL_MARKS}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {selectedReport?.chapters?.map((chapter, index) => {
        const chapterNameWords = chapter.CHAPTER.split(" ");
        const isLongChapterName = chapterNameWords.length > 4;
        const chapterStyle = {
          fontSize: isLongChapterName ? "12px" : "inherit",
          lineHeight: isLongChapterName ? "20px" : "10px"
        };

        const performanceStyle = {
          color: chapter.PERFORMANCE_METRICS === "Keep it up" ? "#2CBE6A" : "#FF5353",
          marginBottom: isLongChapterName ? "1rem" : "0rem"
        };

        return (
          <div key={index} className="AdRp-main-contMob">
            <div className="AdRp-bodyitems1">
              <h3 style={chapterStyle}>{chapter.CHAPTER}</h3>
              <p style={performanceStyle}>{chapter.PERFORMANCE_METRICS}</p>
              <div className="AdRp-marksCont">
                <h4>Marks Achieved</h4>
                <p>
                  <span>{chapter.MARKS_SCORED}</span>/{chapter.TOTAL_MARKS}
                </p>
                <img
                  className="AdRp-mob-epandIcons"
                  onClick={() => handleExpand(index)}
                  src={!expandedChapters[index] ? down : up}
                  alt="arrow"
                />
              </div>
            </div>
            {expandedChapters[index] && (
              <div className="AdRp-inMob-cont">
                <div className="AdRp-header-cont">
                  <p className="AdRp-header-contp2">Qs</p>
                  <p className="AdRp-header-contp3">Correct/Wrong/Unattempted</p>
                </div>
                <div className="AdRp-bodyitems">
                  <div className="AdRp-bodyitems2">{chapter.TOTAL_QUESTIONS_ASKED}</div>
                  <div className="AdRp-bodyitems3">
                    <img src={RightDot} alt="Correct Icon" />
                    <p>{chapter.QUESTION_STATUS_CORRECT}</p>
                    <img src={WrongDot} alt="Wrong Icon" />
                    <p>{chapter.QUESTION_STATUS_WRONG}</p>
                    <img src={Gray} alt="Unattempted Icon" />
                    <p>{chapter.QUESTION_STATUS_UNATTEMPTED}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AdvanceReport;
